var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"h-full"},[_c('ArticleCard',{attrs:{"title":_vm.values.title,"text":_vm.values.text,"image":_vm.values.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }